import { ReactElement, ReactNode, useState } from "react"
import { v4 as uuid4 } from "uuid"

import CreateEbDeviceProvider from "./baseProviders/createEbDeviceProvider"
import { useGetUserData } from "../../../../../hooks/useGetUserData"
import { getEmptyHpDeviceFormData } from "../../formSpecs/hpSpec"
import { HpDeviceFormData } from "../../types/providerTypes"

interface IPublishEbDeviceProviderProps {
    children: ReactNode
}

/** Provide for the publish Electric Boiler provider form */
const PublishEbDeviceProvider = ({
    children,
}: IPublishEbDeviceProviderProps): ReactElement => {
    const [formData, setFormData] = useState<HpDeviceFormData>(
        getEmptyHpDeviceFormData()
    )

    const { isEnaSysAdmin } = useGetUserData()

    const [attachmentUUID] = useState<string>(uuid4())

    return (
        <CreateEbDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={false}
            canEditManufacturer={isEnaSysAdmin}
            attachmentUUID={attachmentUUID}
        >
            {children}
        </CreateEbDeviceProvider>
    )
}

export default PublishEbDeviceProvider
